import { DateTime } from "luxon";

/**
 * Normalizes form funnel answer values so that formAnswers only contains
 * serialization-safe primitives. Specifically, converts Luxon DateTime objects
 * to "yyyy-MM-dd" strings before they hit JSON.stringify (sessionStorage) or
 * the GraphQL transport.
 */
export function normalizeFunnelAnswers(
  values: Record<string, unknown>,
): Record<string, unknown> {
  const normalized: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(values)) {
    normalized[key] = DateTime.isDateTime(value)
      ? value.toFormat("yyyy-MM-dd")
      : value;
  }
  return normalized;
}
